import React, { useState } from "react";
import MenuManagement from "./MenuManagement";
import OrderManagement from "./OrderManagement";
import AddOnsManagement from "./AddOnsManagement";
import RestaurantSettings from "./RestaurantSettings";
import SubscriptionManagement from "./SubscriptionManagement";
import SubscribedMembersManagement from "./SubscribedMembersManagement";
import TodaysMealManagement from "./TodaysMealManagement";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/images/logo.jpeg";

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("orders");
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <img src={logo} alt="Logo" className="h-10 w-10 rounded-full" />
            <h1 className="text-2xl font-bold text-gray-900">Admin Dashboard</h1>
          </div>
          <button
            onClick={logout}
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition"
          >
            Logout
          </button>
        </div>
      </header>

      {/* Tabs */}
      <div className="mx-auto px-2 sm:px-2 lg:px-2 py-6">
        <div className="flex space-x-4 border-b border-gray-200 mb-6 overflow-x-auto whitespace-nowrap">
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "menu"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("menu")}
          >
            Menu Management
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "orders"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("orders")}
          >
            Order Management
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "addons"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("addons")}
          >
            Add-ons Management
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "settings"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("settings")}
          >
            Restaurant Settings
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "subscriptions"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("subscriptions")}
          >
            Subscriptions
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "add-subscription"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("add-subscription")}
          >
            Add Subscription
          </button>
          <button
            className={`pb-2 px-4 font-medium transition ${activeTab === "todays-meal"
              ? "border-b-2 border-green-500 text-green-600"
              : "text-gray-500 hover:text-gray-700"
              }`}
            onClick={() => setActiveTab("todays-meal")}
          >
            Today's Meal
          </button>
        </div>

        {/* Content */}
        <div>
          {activeTab === "menu" && <MenuManagement />}
          {activeTab === "orders" && <OrderManagement />}
          {activeTab === "addons" && <AddOnsManagement />}
          {activeTab === "settings" && <RestaurantSettings />}
          {activeTab === "subscriptions" && <SubscriptionManagement />}
          {activeTab === "add-subscription" && <SubscribedMembersManagement />}
          {activeTab === "todays-meal" && <TodaysMealManagement />}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
